import { formatDiamondShape, formatMetalType } from '../../utils/format-labels'
import _ from 'lodash'

export const NONE = 'None'

const appendUnit = (val) => {
  if (val !== NONE) {
    val = val + ' mm'
  }
  return val
}

export const formatShankWidth = (data) => {
  let shankShape = _.get(data, 'shank.shape')
  if (shankShape === 'straight') {
    return appendUnit(_.get(data, 'shank.straight_width_in_mm', NONE))
  } else if (shankShape === 'taper_in_towards_centre' || shankShape === 'taper_out_towards_centre') {
    return `${appendUnit(_.get(data, 'shank.tapered_min_width_in_mm'))} / ${appendUnit(_.get(data, 'shank.tapered_max_width_in_mm'))}`
  }
}

const formatExistenceDetails = (val) => {
  val = _.defaultTo(val, NONE)
  if (val !== NONE) {
    val = 'Yes'
  }
  return val
}

export const formatHaloWidth = (data) => {
  if (!_.has(data, 'primary_diamond.primary_diamond_halo')) {
    return '-'
  }

  let haloWidth = _.get(data, 'primary_diamond.primary_diamond_halo.width_in_mm')
  if (haloWidth) {
    return appendUnit(haloWidth)
  } else {
    return '-'
  }
}

export const formatPrimaryMetalType = (data) => {
  return formatMetalType(_.get(data, 'primary_metal_type.metal_type'))
}

export const formatHalo = (data) => {
  let jewelleryType = _.get(data, 'jewellery_type')
  let centreHaloType = _.get(data, 'primary_diamond.primary_diamond_halo.style')
  let basketType = _.get(data, 'basket_type')
  switch (jewelleryType) {
    case 'engagement_ring':
      return displayCentreHaloStyle(centreHaloType)
    case 'female_wedding_band':
      return '-'
    case 'male_wedding_band':
      return '-'
    case 'stud_earring':
      return basketType === 'standard_solitaire' ? '-' : displayCentreHaloStyle(centreHaloType)
    case 'pendant':
      return basketType === 'standard_solitaire' ? '-' : displayCentreHaloStyle(centreHaloType)
    default:
      return '-'
  }
}

export const displayCentreHaloStyle = (centreHaloStyle) => {
  if (centreHaloStyle === 'single') {
    return 'Single'
  } else if (centreHaloStyle === 'double') {
    return 'Double'
  } else {
    return NONE
  }
}

export const formatRingSize = (data) => {
  return _.defaultTo(_.get(data, 'ring_size.size_code', NONE), NONE)
}

export const formatMultiStone = (data) => {
  let jewelleryType = _.get(data, 'jewellery_type')
  let multiStoneVal = _.get(data, 'multi_stone.setting')

  if (jewelleryType === 'engagement_ring' || jewelleryType === 'female_wedding_band') {
    if (!multiStoneVal) {
      return NONE
    }
  }

  if (multiStoneVal) {
    return _.startCase(multiStoneVal)
  } else {
    return '-'
  }
}

export const formatCathedralShoulder = (data) => {
  let cathedralShoulder = _.get(data, 'prong.has_cathedral_shoulder')
  if (cathedralShoulder === 'yes') {
    return 'Yes'
  } else if (cathedralShoulder === 'no') {
    return 'No'
  } else if (cathedralShoulder === 'half_diamond') {
    return 'Yes (Half Diamond)'
  } else {
    return '-'
  }
}

export const formatPrimaryDiamondShape = (data) => {
  if (!_.has(data, 'primary_diamond')) {
    return '-'
  }
  let primaryDiamondShape = _.get(data, 'primary_diamond.shape', '-')
  if (primaryDiamondShape) {
    return _.startCase(formatDiamondShape(primaryDiamondShape))
  } else {
    return '-'
  }
}

export const formatProngStyle = (data) => {
  let prongStyle = _.get(data, 'prong.style')
  if (prongStyle) {
    return _.startCase(prongStyle)
  } else {
    return '-'
  }
}

export const formatProngNumber = (data) => {
  return _.defaultTo(_.get(data, 'prong.num_of_prongs'), '-')
}

export const formatShankDiamonds = (data) => {
  let shankTopDiamond = _.get(data, 'shank.shank_top_diamond')
  let shankSideDiamond = _.get(data, 'shank.shank_side_diamond')
  if (shankTopDiamond && shankSideDiamond) {
    return 'Top/Sides'
  } else if (shankTopDiamond) {
    return 'Top'
  } else if (shankSideDiamond) {
    return 'Sides'
  } else {
    return NONE
  }
}

export const formatSpecialFinish = (data) => {
  let jewelleryType = _.get(data, 'jewellery_type')
  let specialFinish = _.get(data, 'special_finish.style')
  let basketType = _.get(data, 'basket_type')

  if (jewelleryType === 'stud_earring' || jewelleryType === 'pendant') {
    if (basketType === 'standard_solitaire') {
      return '-'
    } else if (basketType === 'custom') {
      if (specialFinish && specialFinish === 'satin_brushed') {
        return 'Satin/Brushed'
      } else if (specialFinish) {
        return _.startCase(specialFinish)
      } else {
        return NONE
      }
    }
    return NONE
  }

  if (specialFinish && specialFinish === 'satin_brushed') {
    return 'Satin/Brushed'
  } else if (specialFinish) {
    return _.startCase(specialFinish)
  } else {
    return NONE
  }
}

export const formatBasketStyle = (data) => {
  let basketStyle = _.get(data, 'prong.basket_style')
  if (basketStyle) {
    if (basketStyle === 'v_basket') {
      return 'V-Basket'
    } else {
      return _.startCase(basketStyle)
    }
  } else {
    return '-'
  }
}

export const formatBasketType = (data) => {
  let basketType = _.get(data, 'basket_type')
  if (basketType) {
    if (basketType === 'custom') {
      return 'Custom'
    } else if (basketType === 'standard_solitaire') {
      return 'Standard Solitaire'
    }
  } else {
    return '-'
  }
}

export const formatHandEngraving = (data) => {
  let jewelleryType = _.get(data, 'jewellery_type')
  let handEngraving = _.get(data, 'hand_engraving.style')
  let basketType = _.get(data, 'basket_type')

  if (jewelleryType === 'stud_earring' || jewelleryType === 'pendant') {
    if (basketType === 'standard_solitaire') {
      return '-'
    } else if (basketType === 'custom') {
      if (handEngraving) {
        if (handEngraving === 'top_or_side') {
          return 'Top or Sides'
        } else if (handEngraving === 'top_and_side') {
          return 'Top and Sides'
        } else if (handEngraving === 'minor') {
          return 'Minor'
        }
      } else {
        return NONE
      }
    }
    return NONE
  }

  if (handEngraving) {
    if (handEngraving === 'top_or_side') {
      return 'Top or Sides'
    } else if (handEngraving === 'top_and_side') {
      return 'Top and Sides'
    } else if (handEngraving === 'minor') {
      return 'Minor'
    }
  } else {
    return NONE
  }
}

export const formatShankShape = (data) => {
  let shankShape = _.get(data, 'shank.shape')
  if (shankShape) {
    if (shankShape === 'taper_in_towards_centre') {
      return 'Taper In'
    } else if (shankShape === 'taper_out_towards_centre') {
      return 'Taper Out'
    } else if (shankShape === 'straight') {
      return 'Straight'
    }
  } else {
    return NONE
  }
}

export const formatShankType = (data) => {
  let shankType = _.get(data, 'shank.row_layout')
  if (shankType) {
    switch (shankType) {
      case 'single_row':
        return 'Single'
      case 'split_rows':
        return 'Split'
      case 'intertwined_rows':
        return 'Intertwined'
      case 'double_rows':
        return 'Double'
      default:
        return _.startCase(shankType)
    }
  } else {
    return NONE
  }
}

export const formatBail = (data) => {
  if (!(_.get(data, 'basket_type') === 'custom')) {
    if (!_.has(data, 'bail') || _.isNull(_.get(data, 'bail'))) {
      return '-'
    }
  }

  let bailType = _.get(data, 'bail.bail_type')
  if (bailType) {
    if (bailType === 'tapered') {
      return 'Tapered'
    } else if (bailType === 'straight') {
      return 'Straight'
    }
  } else {
    return NONE
  }
}

export const formatBailDiamond = (data) => {
  if (!_.has(data, 'bail.bail_diamond')) {
    return '-'
  }
  return formatExistenceDetails(_.get(data, 'bail.bail_diamond.shape', NONE))
}

export const formatAdditionalDiamond = (data) => {
  let jewelleryType = _.get(data, 'jewellery_type')
  let additionalDiamonds = _.get(data, 'additional_diamonds')
  let basketType = _.get(data, 'basket_type')

  if (_.isEmpty(additionalDiamonds)) {
    if (jewelleryType === 'stud_earring' || jewelleryType === 'pendant') {
      if (basketType === 'standard_solitaire') {
        return '-'
      } else if (basketType === 'custom') {
        return NONE
      }
    } else {
      return NONE
    }
  } else {
    return 'Yes'
  }
}

export const formatChainMetal = (data) => {
  return formatMetalType(_.get(data, 'pendant_chain.metal_type_enum')) || '-'
}

export const formatChainLength = (data) => {
  let chainLength = _.get(data, 'pendant_chain.length_enum')
  if (chainLength) {
    if (chainLength === 'inches_16') {
      return '16 Inches'
    } else if (chainLength === 'inches_18') {
      return '18 Inches'
    } else if (chainLength === 'inches_20') {
      return '20 Inches'
    }
  } else {
    return '-'
  }
}

export const formatChainWidth = (data) => {
  let chainWidth = _.get(data, 'pendant_chain.width_enum')
  if (chainWidth) {
    if (chainWidth === 'light') {
      return 'Light'
    } else if (chainWidth === 'medium') {
      return 'Medium'
    } else if (chainWidth === 'heavy') {
      return 'Heavy'
    }
  } else {
    return '-'
  }
}

export const formatPrimaryDiamondQty = (data) => {
  let primaryDiamondQty = _.get(data, 'primary_diamond_qty')
  if (primaryDiamondQty > 0) {
    return primaryDiamondQty
  } else {
    return '-'
  }
}



// WEBPACK FOOTER //
// ./src/components/jewelry-details/field-formatters.js